<template>
  <v-expansion-panel-content>
    <Navigate previous />
    <ModelInfo v-if="!onlyAcc" />
    <SeatSummary v-if="!onlyAcc" />
    <AccessorySummary />

    <v-form v-model="valid" ref="checkout">
      <p v-if="foldsofhonor">All orders supporting Folds of Honor will have a Folds of Honor patch attached to the front driver side and passenger side seats, on the front of the backrests, if those seats are ordered, and Ruff Tuff will donate a portion of the purchase price to Folds of Honor.</p>
      <v-row v-if="customer">
        <v-col cols="12">
          <v-switch
          v-model="dropShip"
          label="Drop Ship - Select this option to manually enter a shipping address"
          ></v-switch>
        </v-col>
      </v-row>
      <v-row v-if="addresses.length && !dropShip">
        <v-col cols="12">
          <p style="margin: -16px 0 0 8px"><strong>or</strong> choose a saved address below</p>
        </v-col>
      </v-row>
      <v-row v-if="addresses.length && !dropShip">
        <v-col cols="12">
          <v-select
          filled
          :items="addresses"
          label="Saved Addresses"
          item-text="AddressLine1"
          return-object
          v-model="selectedAddress" />
        </v-col>
      </v-row>
      <h5>Shipping Address (US only)</h5>
      <p class="small">Orders shipping to addresses in Canada must be placed by phone. Please call Ruff Tuff at 801-972-5845.</p>
      <v-row>
        <v-col cols="12" sm="6">
          <v-text-field label="Contact Name" required :rules="required" v-model="address.shipping.Contact" />
        </v-col>
        <v-col cols="12" sm="6">
          <v-text-field label="Purchase Order Number" v-model="poNumber" maxlength="20" v-if="!customer" />
          <v-text-field label="Purchase Order Number" v-model="poNumber" maxlength="20" required :rules="required" v-else />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="6">
          <v-text-field label="Address 1" required :rules="required" :disabled="!dropShip && customer !== null" v-model="address.shipping.AddressLine1" />
        </v-col>
        <v-col cols="12" sm="6">
          <v-text-field label="Address 2" v-model="address.shipping.AddressLine2" :disabled="!dropShip  && customer !== null" />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="4">
          <v-text-field label="City" required :rules="required" v-model="address.shipping.City" :disabled="!dropShip  && customer !== null" />
        </v-col>
        <v-col cols="12" sm="4">
          <v-select
          label="State"
          :items="onlyStates"
          :rules="required"
          item-text="name"
          item-value="abbr"
          required
          :disabled="!dropShip  && customer !== null"
          @change="getTax"
          v-model="address.shipping.State" />
        </v-col>
        <v-col cols="12" sm="4">
          <v-text-field
          label="ZIP/Postal Code"
          required
          :rules="required"
          v-model="address.shipping.ZIP"
          :disabled="!dropShip  && customer !== null"
          @change="getTax" />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <v-switch
          v-model="billingSame"
          label="Billing address same as shipping"
          v-if="!customer"
          ></v-switch>
        </v-col>
      </v-row>
      <section v-if="!billingSame && !customer">
        <h5>Billing Address</h5>
        <v-row>
          <v-col cols="12" sm="6">
            <v-text-field label="Contact Name" required :rules="required" v-model="address.billing.Contact" />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" sm="6">
            <v-text-field label="Address 1" required :rules="required" v-model="address.billing.AddressLine1" />
          </v-col>
          <v-col cols="12" sm="6">
            <v-text-field label="Address 2" v-model="address.billing.AddressLine2" />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" sm="4">
            <v-text-field label="City" required :rules="required" v-model="address.billing.City" />
          </v-col>
          <v-col cols="12" sm="4">
            <v-select
            label="State/Province"
            :items="states"
            :rules="required"
            item-text="name"
            item-value="abbr"
            required
            v-model="address.billing.State" />
          </v-col>
          <v-col cols="12" sm="4">
            <v-text-field label="ZIP/Postal Code" required :rules="required" v-model="address.billing.ZIP" />
          </v-col>
        </v-row>
      </section>
      <v-row>
        <v-col cols="12" sm="6">
          <v-text-field label="Email" v-model="email" required :rules="required" />
        </v-col>
        <v-col cols="12" sm="6">
          <v-text-field label="Phone" v-model="phone" required :rules="required" />
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-textarea label="Additional Information" v-model="moreInfo" />
        </v-col>
      </v-row>
      <v-row v-if="!customer && !hasCoupon">
        <v-col>
          <v-switch label="Have a coupon code?" v-model="hasCoupon" />
        </v-col>
      </v-row>
      <v-row v-if="hasCoupon">
        <v-col cols="6">
          <v-row>
            <v-col cols="9">
              <v-text-field
              label="Coupon Code"
              v-model="couponCode"
              />
              <v-alert v-if="couponMsg" dense colored-border :type="couponMsg.type">{{ couponMsg.message }}</v-alert>
            </v-col>
            <v-col cols="3">
              <v-btn
              color="secondary"
              class="ma-2 white--text"
              @click="applyCoupon"
              >
              Apply
              <v-icon
              right
              dark
              >
              far fa-arrow-alt-circle-right
            </v-icon>
          </v-btn>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
  <v-row v-if="!customer">
    <v-col>
      <v-row>
        <v-col><span style="font-size: 0.875rem; color: rgba(0, 0, 0, 0.54); display: block; text-align: center; font-weight: bold;">For Pay Later and Pay in 4, select PayPal</span></v-col>
      </v-row>
      <v-tabs v-model="paymentMethod">
        <v-tab>
          Pay with Credit Card
          <v-icon right dark>
            far fa-credit-card-front
          </v-icon>
        </v-tab>
        <v-tab>
          Pay with PayPal
          <v-icon right dark>
            fab fa-paypal
          </v-icon>
        </v-tab>
      </v-tabs>
      <v-tabs-items v-model="paymentMethod">
        <v-tab-item>
          <v-card flat v-if="paymentMethod === 0">
            <v-row v-if="!customer && !hasGiftCard">
              <v-col>
                <v-switch label="Have a gift card?" v-model="hasGiftCard" />
              </v-col>
            </v-row>
            <v-row v-if="hasGiftCard">
              <v-col cols="6">
                <v-row>
                  <v-col cols="9">
                    <v-text-field
                    label="Gift Card"
                    v-model="giftCardCode"
                    />
                    <v-alert v-if="giftCardMsg" dense colored-border :type="giftCardMsg.type">{{ giftCardMsg.message }}</v-alert>
                  </v-col>
                  <v-col cols="3">
                    <v-btn
                    color="secondary"
                    v-if="!giftCard"
                    class="ma-2 white--text"
                    @click="applyGiftCard"
                    >
                    Apply
                    <v-icon right dark>
                      far fa-arrow-alt-circle-right
                    </v-icon>
                  </v-btn>
                  <v-btn
                  color="secondary"
                  v-if="giftCard"
                  class="ma-2 white--text"
                  @click="clearGiftCard"
                  >
                  Remove
                  <v-icon close dark>
                    far fa-close
                  </v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-row v-if="!customer">
              <v-col>
                <v-text-field label="Credit Card Number" required :rules="required" v-model="payment.number" :append-icon="ccIcon"/>
              </v-col>
            </v-row>
            <v-row v-if="!customer">
              <v-col>
                <v-text-field label="CCV" required :rules="required" v-model="payment.ccv" />
              </v-col>
            </v-row>
            <v-row v-if="!customer">
              <v-col cols="12" sm="6">
                <v-select
                label="Expiration Month"
                :items="months"
                :rules="required"
                required
                v-model="payment.expiryMonth" />
              </v-col>
              <v-col cols="12" sm="6">
                <v-select
                label="Expiration Year"
                :items="years"
                :rules="required"
                required
                v-model="payment.expiryYear" />
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-card>
    </v-tab-item>
    <v-tab-item>
      <div id="paypal-button-container"></div>
    </v-tab-item>
  </v-tabs-items>
</v-col>
<v-col>
  <Total
  :shippingPrices="optionPrices"
  :tax="tax"
  :giftAmount="giftCardValueApplied"
  :shipping="shippingAndHandling" />
</v-col>
</v-row>
<v-row v-if="!customer">
  <v-col>
    <v-checkbox
    v-model="promoOptin"
    :label="`Yes! Please use my e-mail address to alert me to special offers and new products. (Note: You may opt out of these e-mails at any time.)`"
    ></v-checkbox>
  </v-col>
</v-row>
<v-row v-if="!customer">
  <v-col>
    <div class="prop-65">
      <img src="../assets/images/prop-65.jpg">
      <p class="prop65"><strong>Warning:</strong> This product can expose you to chemicals, including diisononyl phthalate (DINP), which is known to the state of California to cause cancer. For more information, go to www.P65Warnings.ca.gov</p>
    </div>
  </v-col>
</v-row>
<v-row v-if="paymentMethod === 0">
  <v-col class="d-flex flex-wrap justify-end">
    <v-checkbox
    v-model="agree"
    label="I agree to the Terms and Conditions"
    align-self="end"
    ></v-checkbox>
  </v-col>
</v-row>
</v-form>
<v-snackbar v-model="hasError" color="error" :timeout="timeout">
  {{ errorMsg }}
</v-snackbar>
<Navigate previous :submit="paymentMethod ? null : submit" :valid="ready && agree" />
</v-expansion-panel-content>
</template>

<style scoped lang="scss">
  .item-total {
    font-size: 20px;
    font-family: $heading-font-family;
  }
  h5 {
    font-family: $body-font-family !important;
    font-size: 20px !important;
    font-weight: 700 !important;
    margin: 20px 0;

    @media screen and (min-width: 600px) {
      font-size: 30px !important;
    }
  }
  h6 {
    font-family: $body-font-family !important;
    font-size: 16px;
    font-weight: 700;
    text-align: left;
    margin: 15px 0 30px;
    justify-content: space-between;
    display: flex;

    @media screen and (min-width: 600px) {
      font-size: 24px;
    }
  }
  .prop-65 {
    display: flex;
    flex-direction: row;
    align-items: center;

    img {
      width: 50px;
      height: 44px;
      margin-right: 15px;
    }

    p {
      font-size: 13px;
      margin-bottom: 0 !important;
    }
  }

  p.coupon-msg {
    padding-left: 0;
    font-size: 14px;
  }

  #paypal-button-container {
    padding: 1rem;
  }

  .theme--light.v-tabs-items {
    background-color: #f5f5f5 !important;
  }

  .v-sheet.v-card {
    background-color: #f5f5f5 !important;
    padding: 1rem;
  }

  .v-tab {
    width: 100%;
  }

  .v-tab--active {
    background-color: #f5f5f5;
  }
</style>
<script>
  import { mapState, mapGetters, mapMutations } from 'vuex'
  import { loadScript } from '@paypal/paypal-js';
  import CCType from 'credit-card-type'
  import router from '@/router'
  import { calculateTax, calculateShipping, getDiamondQuiltOption, requiredRule } from '@/utils'
  import states from '@/services/states'
  import Invoice from '@/services/invoice'
  import Coupon from '@/services/coupon'
  import GiftCard from '@/services/giftcard'
  import Order from '@/services/order'
  import Paypal from '@/services/paypal'
  import ModelInfo from './ModelInfo'
  import SeatSummary from './SeatSummary'
  import AccessorySummary from './AccessorySummary'
  import Total from './Total'
  import Navigate from './Navigate'

  const CCIcons = [
  'visa',
  'mastercard',
  'american-express',
  'diners-club',
  'discover',
  'jcb'
  ]

  export default {
    components: {
      ModelInfo,
      SeatSummary,
      AccessorySummary,
      Total,
      Navigate,
    },
    data () {
      return {
        agree: false,
        states,
        tax: 0,
        valid: true,
        ready: true,
        required: requiredRule,
        hasError: false,
        timeout: 20000,
        hasCoupon: false,
        couponCode: '',
        couponMsg: null,
        hasGiftCard: false,
        giftCardCode: '',
        giftCardMsg: null,
        errorMsg: '',
        invoice: '',
        poNumber: '',
        dropShip: false,
        billingSame: false,
        email: '',
        phone: '',
        moreInfo: '',
        promoOptin: 0,
        paymentMethod: 0,
        paypalLoaded: false,
        payment: {
          number: '',
          expiryMonth: '',
          expiryYear: '',
          ccv: '',
        },
      months: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
      selectedAddress: null,
      address: {
        shipping: {
          Contact: '',
          AddressLine1: '',
          AddressLine2: '',
          City: '',
          State: '',
          ZIP: ''
        },
        billing: {
          Contact: '',
          AddressLine1: '',
          AddressLine2: '',
          City: '',
          State: '',
          ZIP: ''
        }
      },
      optInUtvGiveaway: null,
      giveawayCerts: {
        age21: false,
        contiguousUS: false,
        transportAck: false,
        termsAccepted: false
      }
    }
  },
  computed: {
    ...mapState([
      'model',
      'variations',
      'optionPrices',
      'accessories',
      'customer',
      'addresses',
      'order',
      'coupon',
      'src',
      'giftCard'
      ]),
    ...mapGetters([
      'getSubtotal',
      'subtotal',
      'discount',
      'freeShipping',
      ]),
    foldsofhonor: function() {
      return this.src === 'foldsofhonor'
    },
    years: function() {
      const year = (new Date()).getFullYear()
      return Array(10).fill().map((_, i) => year + i)
    },
    options: function() {
      const options = {}
      Object.keys(this.variations).forEach(position => {
        if (this.variations[position].options) {
          options[position] = this.variations[position].options.filter(option => option.added)
        }
      })
      return options
    },
    hasFlex: function() {
      return this.accessories['FLEX']?.quantity
    },
    ccIcon: function() {
      const card = CCType(this.payment.number)
      if (!card.length || !this.payment.number.length || CCIcons.indexOf(card[0].type) < 0) {
        return 'fa-credit-card'
      }

      return card[0].type === 'american-express' ? 'fab fa-cc-amex' : `fab fa-cc-${card[0].type}`
    },
    totalPrice: function() {
      return Number((this.actualTotal + this.shippingAndHandling + this.tax).toFixed(2))
    },
    shippingAndHandling: function() {
      return this.customer
      ? 0
      : calculateShipping(this.address.shipping.State, this.variations, this.actualTotal, this.freeShipping, this.optionPrices, this.onlyAcc, this.hasFlex)
    },
    giftCardValueApplied: function() {
      return this.giftCard
      ? Math.min(this.totalPrice, this.giftCard.remainingValue)
      : 0
    },
    actualTotal: function() {
      return this.customer
      ? this.getSubtotal('wholesale')
      : this.subtotal - this.discount

    },
    onlyStates: function() {
      return this.states.filter(state => state.country === 'US');
    },
    onlyAcc() {
      const seatRows = Object.values(this.variations || {})
      const hasValidSeats = seatRows.some(v => v && (v.trim || v.insert))
      const hasAccessories = Object.keys(this.accessories || {}).length > 0
      return !hasValidSeats && hasAccessories
    },
    allGiveawayCertsChecked() {
      return Object.values(this.giveawayCerts).every(Boolean)
    },
    giveawayResolved() {
      return this.optInUtvGiveaway !== null
    },
    giveawayValidForSubmit() {
      if (this.customer) {
        return true
      }

      if (this.optInUtvGiveaway === false) {
        return true
      }

      if (this.optInUtvGiveaway === true) {
        return this.allGiveawayCertsChecked
      }

    return false // null / not chosen
  }

},
watch: {
  selectedAddress: function(address) {
    this.address.shipping = address
  },
  billingSame: function(same) {
    if (same) {
      this.address.billing = this.address.shipping
    } else {
      this.address.billing = {}
    }
  },
  paymentMethod: function(method) {
    if (method === 1) {
      this.loadPaypal()
    }
  },
  // optInUtvGiveaway(val) {
  //   /* eslint-disable-next-line no-console */
  //   console.log('optInUtvGiveaway:', val)
  // }
},
mounted () {
  this.getInvoice()
},
updated () {
  this.getTax();
},
methods: {
  ...mapMutations([
    'setCoupon',
    'setGiftCard',
    'setOrder',
    ]),
  async getInvoice() {
    this.invoice = await Invoice.get()
  },
  loadPaypal() {
    if (this.paypalLoaded) {
      return
    }

    const _this = this

    loadScript({
      'client-id': process.env.VUE_APP_PAYPAL_CLIENT_ID,
      'disableFunding': 'card'
    }).then((paypal) => {
      paypal.Buttons({
        style: {
          shape: 'rect',
          layout: 'vertical',
          color: 'gold',
          label: 'paypal',
        },
        message: {
          amount: _this.totalPrice,
          currency: 'USD',
        },
        async createOrder() {
          if (_this.validate()) {
            _this.setOrder(_this.prepare())
          } else {
            _this.errorMsg = 'Please fill out all required fields'
            _this.hasError = true
            return
          }

          try {
            const orderData = await Paypal.create({
              totalPrice: _this.totalPrice,
            })

            if (orderData.id) {
              return orderData.id
            }
            const errorDetail = orderData?.details?.[0]
            const errorMessage = errorDetail
            ? `${errorDetail.issue} ${errorDetail.description} (${orderData.debug_id})`
            : JSON.stringify(orderData)

            throw new Error(errorMessage)
          } catch (error) {
            this.hasError = true
            this.errorMsg = 'Could not initiate PayPal Checkout'
            /* eslint-disable-next-line no-console */
            console.error(`Could not initiate PayPal Checkout...<br><br>${error}`)
          }
        },
        async onApprove(data, actions) {
          try {
            const orderData = await Paypal.capture(data.orderID)

            const errorDetail = orderData?.details?.[0];

            if (errorDetail?.issue === 'INSTRUMENT_DECLINED') {
              return actions.restart();
            } else if (errorDetail) {
              throw new Error(
                `${errorDetail.description} (${orderData.debug_id})`
                );
            } else if (!orderData.purchase_units) {
              throw new Error(JSON.stringify(orderData));
            } else {
                // _this.order.orderId = data.orderID
                _this.order.payPalPayment = _this.totalPrice
                _this.order.payPalPaymentType = Object.keys(orderData.payment_source)[0]
                Order.submit(_this.order)
                .then(_this.success)
                .catch(_this.handleError)
                .finally(() => _this.ready = true)
              }
            } catch (error) {
              this.hasError = true
              this.errorMsg = `Error processing PayPal payment: ${error}`
              /* eslint-disable-next-line no-console */
              console.error(error);
            }
          } ,
        }).render('#paypal-button-container')

      this.paypalLoaded = true
    }).catch((err) => {
      /* eslint-disable-next-line no-console */
      console.error('Failed to load Paypal', err)
    })
  },
  validate () {
    return this.$refs.checkout.validate()
},
getTax() {
  if (this.customer && this.customer.State === 'UT') {
    this.tax = 0
  } else if (this.address.shipping.State && this.address.shipping.ZIP && this.address.shipping.ZIP.length >= 5) {
    this.tax = calculateTax(this.address.shipping.State, this.actualTotal);
  }
},
applyCoupon () {
  this.couponMsg = null;
  Coupon.get(this.couponCode)
  .then(res => {
    this.setCoupon(res)
    this.couponMsg = {
      type: 'success',
      message: res.message
    }
    this.getTax()
  })
  .catch(e => {
    this.setCoupon(null)
    this.couponMsg = {
      type: 'error',
      message: e.response?.data?.Message
    }
  })
},
applyGiftCard () {
  this.giftCardMsg = null;
  GiftCard.get(this.giftCardCode)
  .then(res => {
    this.setGiftCard(res)
    this.giftCardMsg = {
      type: 'success',
      message: `Remaining value: $${res.remainingValue.toFixed(2)}`
    }
  })
  .catch(e => {
    this.setGiftCard(null)
    this.giftCardMsg = {
      type: 'error',
      message: e.response?.data?.error || 'An error occurred. Please contact support.'
    }
  })
},
clearGiftCard () {
  this.giftCardMsg = null;
  this.giftCardCode = '';
  this.setGiftCard(null)
},
submit() {
  if (this.validate()) {
    this.ready = false;
    Order.submit(this.prepare())
    .then(this.success)
    .catch(this.handleError)
    .finally(() => this.ready = true)
  } else {
    this.errorMsg = 'Please fill out all required fields'
    this.hasError = true
  }
},
success(order) {
  this.setOrder(order)

  this.$gtm.trackEvent({
    category: 'Orders',
    orderId: order.orderId,
    orderAmount: this.totalPrice,
    value: this.totalPrice,
  })

  if (window.uetq) {
    window.uetq.push({
      ec: 'purchase',
      ea: 'Order Create',
      el: 'Order Amount',
      ev: this.totalPrice,
      gv: this.totalPrice,
      gc: 'USD'
    })
  }

  const thankYouPath = this.customer ? '/thanks-reseller' : '/thanks-retail'

  router.push({
    path: thankYouPath
  })
},
handleError(res) {
  this.hasError = true
  const nusMessage = this.customer ? '' : 'check your address and payment information and try again, or'
  this.errorMsg = `Sorry, there was an error placing your order. Please ${nusMessage} call us at 800-453-8830. (This alert will disappear after 20 seconds.) ${res.response?.data?.Message || res.response?.data?.error}`
  /* eslint-disable-next-line no-console */
      console.error(res) // this is needed
    },
    getDiamondQuilting(variation) {
      return getDiamondQuiltOption(variation)?.added ? 1 : 0;
    },
    prepare() {
      const order = {
        invoiceNumber: this.invoice.nextWebInvoiceNumber,
        orderId: '00000000-0000-0000-0000-000000000000',
        orderStatus: 0,
        makeId: null,
        modelId: null,
        vehicleYear: null,
        contactName: this.address.shipping.Contact,
        retailCustomerEmail: this.email,
        retailCustomerPhone: this.phone,
        totalPrice: this.totalPrice,
        shippingAndHandling: this.shippingAndHandling,
        tax: this.tax,
        giftCardNumber: this.giftCardCode,
        giftCardPayment: this.giftCardValueApplied,
        cust_Name: this.address.shipping.Contact,
        cust_Address: this.address.billing.AddressLine1,
        cust_Address2: this.address.billing.AddressLine2,
        cust_City: this.address.billing.City,
        cust_State: this.address.billing.State,
        cust_ZIP: this.address.billing.ZIP,
        cust_Email: this.email,
        cust_Phone: this.phone,
        ship_Name: this.address.shipping.Contact,
        ship_Address: this.address.shipping.AddressLine1,
        ship_Address2: this.address.shipping.AddressLine2,
        ship_City: this.address.shipping.City,
        ship_State: this.address.shipping.State,
        ship_ZIP: this.address.shipping.ZIP,
        ship_Email: this.email,
        ship_Phone: this.phone,
        pONumber: this.poNumber,
        cust_PromoEmailOptIn: this.promoOptin,
        additionalInfo: this.moreInfo,
        optInUtvGiveaway: this.optInUtvGiveaway === true,
      }

      if (!this.onlyAcc) {
        order.makeId = this.model.makeId
        order.modelId = this.model.modelId
        order.vehicleYear = this.model.year
      }

      if (this.coupon) {
        order.discountCode = this.coupon.discountCode
      }

      if (this.src) {
        order.attribution = this.src
      }

      if (this.customer) {
        order.customerId = this.customer.Id;
        order.cust_AccountNumber = this.customer.AccountNumber;
        order.cust_Discount = this.customer.Discount;
        order.dropShipAddress = this.address.shipping.AddressLine1;
        order.dropShipAddress2 = this.address.shipping.AddressLine2;
        order.dropShipCity = this.address.shipping.City;
        order.dropShipState = this.address.shipping.State;
        order.dropShipZIP = this.address.shipping.ZIP;
        order.resellerPhone = this.phone;
        order.resellerEmail = this.email;
        order.shippingAddressId = this.selectedAddress?.ShippingAddressID;
        order.resellerFlag = true;
      } else {
        order.card = this.payment
      }

      if (this.variations.front) {
        order.frontSeatMatchId = this.variations.front.SeatMatchID;
        order.frontSeatStyleId = this.variations.front.SeatStyleId;
        order.frontSeatVariationId = this.variations.front.frontSeatVariationID;
        if (this.variations.front.trim) {
          order.frontSeatMaterialId = this.variations.front.trim.materialId;
          order.frontSeatColorId = this.variations.front.trim.colorId;
        }
        if (this.variations.front.insert) {
          order.frontInsertMaterialId = this.variations.front.insert.materialId;
          order.frontInsertColorId = this.variations.front.insert.colorId;
          order.frontDiamondQuilting = this.getDiamondQuilting(this.variations.front);
        }
        if (order.frontDiamondQuilting) {
          const frontQuilt = getDiamondQuiltOption(this.variations.front);

          if (frontQuilt?.style?.id) {
            order.frontQuiltingStyle = frontQuilt.style.id;
          }

          if (frontQuilt?.color?.id) {
            order.frontQuiltingThreadColorId = frontQuilt.color.id;
          }
        }

        Object.assign(order, prepOptions(this.variations.front, 'front'));
      }
      if (this.variations.rear) {
        order.rearSeatMatchId = this.variations.rear.RearSeatMatchID;
        order.rearSeatStyleId = this.variations.rear.SeatStyleId;
        order.rearSeatVariationId = this.variations.rear.rearSeatVariationID;
        if (this.variations.rear.trim) {
          order.rearSeatMaterialId = this.variations.rear.trim.materialId;
          order.rearSeatColorId = this.variations.rear.trim.colorId;
        }
        if (this.variations.rear.insert) {
          order.rearInsertColorId = this.variations.rear.insert.colorId;
          order.rearInsertMaterialId = this.variations.rear.insert.materialId;
          order.rearDiamondQuilting = this.getDiamondQuilting(this.variations.rear);
        }
        if (order.rearDiamondQuilting) {
          const rearQuilt = getDiamondQuiltOption(this.variations.rear);

          if (rearQuilt?.style?.id) {
            order.rearQuiltingStyle = rearQuilt.style.id;
          }

          if (rearQuilt?.color?.id) {
            order.rearQuiltingThreadColorId = rearQuilt.color.id;
          }
        }
        Object.assign(order, prepOptions(this.variations.rear, 'rear'));
      }
      if (this.variations.third) {
        order.thirdSeatMatchId = this.variations.third.ThirdSeatMatchID;
        order.thirdSeatStyleId = this.variations.third.SeatStyleId;
        order.thirdSeatVariationId = this.variations.third.thirdSeatVariationID;
        if (this.variations.third.trim) {
          order.thirdSeatMaterialId = this.variations.third.trim.materialId;
          order.thirdSeatColorId = this.variations.third.trim.colorId;
        }
        if (this.variations.third.insert) {
          order.thirdInsertMaterialId = this.variations.third.insert.materialId;
          order.thirdInsertColorId = this.variations.third.insert.colorId;
          order.thirdDiamondQuilting = this.getDiamondQuilting(this.variations.third);
        }
        if (order.thirdDiamondQuilting) {
          const thirdQuilt = getDiamondQuiltOption(this.variations.third);

          if (thirdQuilt?.style?.id) {
            order.thirdQuiltingStyle = thirdQuilt.style.id;
          }

          if (thirdQuilt?.color?.id) {
            order.thirdQuiltingThreadColorId = thirdQuilt.color.id;
          }
        }
        Object.assign(order, prepOptions(this.variations.third, 'third'));
      }

      Object.assign(order, prepAccessories(this.accessories));

      return order;
    }
  }
}

function prepOptions(seat, pos) {
  const options = {}
  seat.options.forEach(function(option) {
    if (option.added) {
      if (option.name === 'TacticalPackage') {
        options[option.alias] = option.qty
      } else {
        options[pos + option.alias] = option.qty
      }
    }
  });
  return options
}

function prepAccessories(accessories) {
  let products = {}
  let i = 0
  for (const acc of Object.values(accessories)) {
    if (acc.added) {
      i++
      products[`otherProd${i}PartNum`] = acc.partNumber
      products[`otherProd${i}Quantity`] = acc.quantity
      products[`otherProd${i}Size`] = null
      products[`otherProd${i}Color`] = null
    }
  }

  return products
}

</script>
